// src/services/locationService.js
import axios from "axios";
import { domain } from "../auth/domain";

const api = axios.create({
  baseURL: domain,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `JWT ${token}`;
  }
  return config;
});

const parseError = (error) => {
  if (error.response?.data?.detail) return error.response.data.detail;
  if (error.response?.data) {
    return (
      Object.values(error.response.data).flat().join(" ") ||
      "Failed to load locations."
    );
  }
  return error.message || "Failed to load locations.";
};

export const fetchRegions = async () => {
  try {
    const { data } = await api.get("locations/regions/");
    return data;
  } catch (error) {
    throw new Error(parseError(error));
  }
};

export const fetchDistricts = async (region) => {
  try {
    const { data } = await api.get("locations/districts/", {
      params: { region },
    });
    return data;
  } catch (error) {
    throw new Error(parseError(error));
  }
};
